import fetch from '../../../../utils/fetch';
import * as types from './mutation_types';
import moment from 'moment';

const getItems = ({ commit }, page = 'testimonials') => {
  commit(types.TOGGLE_LOADING);

  fetch(page)
    .then(response => response.json())
    .then((data) => {
      data['hydra:member'].forEach(testimonial => {        
        testimonial.created = moment(testimonial.created).utc().format("Y-MM-DD");        
      });
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ITEMS, data['hydra:member']);
      commit(types.SET_VIEW, data['hydra:view']);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export const getSortedItems = ({ commit }, options) => {
  let path;
  if (options.page) {
    path = `testimonials?order[${options.field}]=${options.order}&page=${options.page}`;
  } else if (options.field && options.order) {
    path = `testimonials?order[${options.field}]=${options.order}`;
  } else {
    path = 'testimonials';
  }
  commit(types.TOGGLE_LOADING); 
  fetch(path)
  .then(response => response.json())
  .then((data) => {
    data['hydra:member'].forEach(testimonial => {        
      testimonial.created = moment(testimonial.created).utc().format("Y-MM-DD");        
    });
    commit(types.TOGGLE_LOADING);
    commit(types.SET_ITEMS, data['hydra:member']);
    commit(types.SET_VIEW, data['hydra:view']);
  })
  .catch((e) => {
    commit(types.TOGGLE_LOADING);
    commit(types.SET_ERROR, e.message);
  });
};

export const getSelectItems = (
  { commit },
  { page = 'testimonials', params = { properties: ['@id', 'name'] } } = {},
) => {
  commit(types.TOGGLE_LOADING);

  fetch(page, { params })
    .then(response => response.json())
    .then(data => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_SELECT_ITEMS, data['hydra:member']);
    })
    .catch(e => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export default getItems;



// WEBPACK FOOTER //
// ./src/store/modules/testimonial/list/actions.js